document.addEventListener('turbo:load', () => {
  const sidebar = document.querySelector('[data-mobile-sidebar]');
  const toggles = document.querySelectorAll('[data-sidebar-toggle]');

  if (!sidebar) return;

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      sidebar.hidden = !sidebar.hidden;
    });
  });
});
